import { limitedWindowAroundCenter } from './limitedWindowAroundCenter'

export const getChartTracks = (chart, numberOfTracks, offset = 0) => {
  const tracks = chart?.tracks || []
  const numericKeys = Object.keys(tracks)
    .map((x) => parseInt(x))
    .filter((x) => !isNaN(x))
  const minPosition = numericKeys.length > 0 ? Math.min(...numericKeys) : 0
  const maxPosition = numericKeys.length > 0 ? Math.max(...numericKeys) : 0

  const [showFrom, showTo] = limitedWindowAroundCenter(chart?.currentPosition ?? minPosition, maxPosition, numberOfTracks, offset * -1)

  const data = {}

  for (let i = showFrom; i <= showTo; i++) {
    data[i] = tracks[i]
  }

  return data
}
